import Vue from 'vue'
import {mask} from 'vue-the-mask'

Vue.directive('mask', mask);